<template>
	<div class="allchain">
		<leftnav class="fl" :itemcode="itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='isshowWaterMark'>
				<div class="index_left_centerpage">
					<div class="whitebox right_topbox">
						<div class="right_boxtitle">
							<span class="fl right_title">{{ replaceTitleKey('省市竞争力研究') }}</span>
							<span class='fl fz18 ml-8 orangefont lh42 cur-pointer hover-line'
								@click="routerlinkarry('/video-courses')">区域经济高质量发展视频课:<b>《城市竞争战略》</b>, 立即观看&gt;</span>
						</div>
						<div>
							<div class="opport-screen-list1 por">
								<dl class="opport-screen bdbe">
									<dt class="fl">竞争力类型</dt>
									<dd class="fl">
										<span :class="cur_type == list.type ? 'a-screen current' : 'a-screen'"
											@click="getCurType(list)" :key="i"
											v-for="(list, i) in type_list">{{ replaceTitleKey(list.title) }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="cur_order_list.length > 0 && cur_type != 3">
									<dt class="fl">竞争力排名</dt>
									<dd class="fl">
										<span :class="cur_order_type == list.value ? 'a-screen current' : 'a-screen'"
											@click="getCurOrderType(list)" :key="i"
											v-for="(list, i) in cur_order_list">{{ list.name }}</span>
									</dd>
								</dl>
								<!-- 概念产业筛选 -->
								<notionScreen :type="1" :refreshNum="navToggleNum" oneLevelTitle="竞争力排名"
									:isShowOneLevelTotal="false" :showLevelNum="3" :token="userdata.token"
									@chooseNotion="chooseNotion" :isClearNotion="isClearNotion"
									:isShowNotionScreen="false" v-show="cur_type == 3">
								</notionScreen>
								<dl class="opport-screen bdbe">
									<dt class="fl">竞争力分布</dt>
									<dd class="fl">
										<span :class="echart_type == list.type ? 'a-screen current' : 'a-screen'"
											@click="getEchartType(list.type)" :key="i"
											v-for="(list, i) in echart_type_list">{{ replaceTitleKey(list.name) }}</span>
									</dd>
								</dl>
							</div>
						</div>
					</div>
					<div class="whitebox oh">
						<!-- 企业分布地图和饼图 -->
						<div class="notion-map ">
							<div class="recommd-map">
								<!-- <div class="oh"><span class="listclose_btn fr"  @click="showEchart=!showEchart">{{showEchart?'隐藏可视化图表':'展开可视化图表'}}</span></div> -->
								<h3 class="title tac mt-2">{{ cur_order_title }}{{ cur_order_unit == '' ? '数量' : '' }}</h3>
								<div class="citymapblock por" v-show="showEchart">
									<chainMap :mapdata="citymapdata_province" :mapUnit="cur_order_unit"
										v-if="citymapdata_province.length > 0 && area_type == 1" :citymapflag="true"
										:mapboxWidth="echartWidth1" :mapboxHeight="800"
										v-on:chartmapclick="chartmapclick" :choosecity='choosecity'
										v-show="echart_type == 'map'">
									</chainMap>
									<div v-if="area_type == 2" v-show="echart_type == 'map'"
										:style="'width:' + echartWidth1 + 'px'" class="map-hot-big" id="map-hot-big"></div>
									<div class="conallEnterprise_pie_db mga" id="conallEnterprise_pie_db"
										:style="'width:' + echartWidth1 + 'px'" v-show="echart_type == 'pie'"></div>
									<div id="qyjz_bar" :class="area_type == 1 ? 'mga heightsm' : 'mag heightbig'"
										v-if="tableData.length > 0" v-show="echart_type == 'bar'"
										:style="'width:' + echartWidth1 + 'px;'"></div>
								</div>
							</div>
						</div>
						<!-- 表格呈现处  20240126隐藏 直接用可视化展示-->
						<!-- <div class="w95mg pb-10 mt-2"> 
						<el-table :data="tableData" height="940" :key="refreshNum" ref="tableData" style="width: 100%"
							row-class-name="enterprise-table-td competitiven-table-td" header-row-class-name="enterprise-table-th">
							<el-table-column type="index" fixed label="排名" width="100" align="center"></el-table-column>
							<el-table-column prop="areaName" fixed label="区域" width="120" align="center">
								<template #default="scope">
									<h5 :class="(userdata.province == scope.row.areaId  || userdata.city == scope.row.areaId )? 'title redfont':'title'">
										{{scope.row.areaName}}
									</h5>
								</template>
</el-table-column>
<el-table-column :key="i" v-for="(list,i) in table_cur_sort" min-width="100" align="center">
	<template slot="header" slot-scope="scope">{{list.name}}<br>{{list.unit}}</template>
	<template #default="scope">
									<p>{{getMoneyNum(list.name,scope.row.data[i])}} </p>
								</template>
</el-table-column>
</el-table>
</div> -->
					</div>
				</div>
			</watermark>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'regional-competitiveness',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	props: {},
	data() {
		return {
			title: "省市区域竞争力",
			echartWidth1: document.body.offsetWidth * 0.8728 * 0.95,
			userdata: {},
			refreshNum: 1,
			navToggleNum: 1,
			showEchart: true,
			itemcode: "",
			pieData: [],
			tableData: [{
				areaNam: "",
				areaId: "",
				data: [0, 0, 0, 0, 0, 0, 0]
			}],
			echart_type_list: [
				{ name: '省市排名柱状图', type: 'bar' },
				{ name: '省市占比饼状图', type: 'pie' },
				{ name: '省市分布全国地图', type: 'map' },
			],
			echart_type: "bar",
			area_type: 1,
			area_type_en: "province",
			cur_type: 1,
			curWebsite: this.$api.getWebsiteType(),
			cur_order_list: [],
			table_cur_sort: [],
			cur_order_type: 1,
			cur_order_title: "世界500强（内资）",
			cur_order_unit: "",
			type_list: [{
				type: 1,
				title: "省市综合竞争力",
				order_type: 1,
				de_order_type: 1,
				order_title: "世界500强（内资）",
				order_unit: "",
				order_list: [{
					value: 1,
					name: "世界500强（内资）",
					unit: "",
				},
				{
					value: 2,
					name: "世界500强（外资）",
					unit: "",
				},
				{
					value: 3,
					name: "中国500强",
					unit: "",
				},
				{
					value: 4,
					name: "中国民营企业500强",
					unit: "",
				},
				{
					value: 5,
					name: "上市公司",
					unit: "",
				},
				{
					value: 6,
					name: "外资企业",
					unit: "",
				},
				{
					value: 7,
					name: "外资企业中国总部",
					unit: "",
				},
				]
			},
			{
				type: 2,
				title: "省市科创竞争力",
				order_type: 2,
				de_order_type: 2,
				order_title: "创新企业",
				order_unit: "",
				order_list: [
					{
						value: 2,
						name: "专精特新小巨人企业",
						unit: "",
					},
					{
						value: 3,
						name: "专精特新中小企业",
						unit: "",
					},
					{
						value: 4,
						name: "高新技术企业",
						unit: "",
					},
					{
						value: 1,
						name: "创新企业",
						unit: "",
					},
				]
			},
			{
				type: 3,
				title: "省市产业竞争力",
				order_type: 1,
				order_title: "先进制造业",
				order_unit: "",
				notion_code: "A",
				order_list: []
			},
			{
				// 竞争力排名: 1=上市公司投资项目数, 2=上市公司投资项目金额, 3=企业拿地投资项目数, 4=企业拿地投资项目面积, 5=企业拿地投资项目金额 (金额:万元，面积:亩)
				type: 4,
				title: "省市本地投资竞争力",
				order_type: 1,
				de_order_type: 1,
				order_title: "上市公司投资项目数",
				order_unit: "",
				order_list: [{
					value: 1,
					name: "上市公司投资项目数",
					unit: "",
				},
				{
					value: 2,
					name: "上市公司投资项目金额",
					unit: "万元",
				},
				{
					value: 3,
					name: "企业拿地投资项目数",
					unit: "",
				},
				{
					value: 4,
					name: "企业拿地投资项目面积",
					unit: "亩",
				},
				{
					value: 5,
					name: "企业拿地投资项目金额",
					unit: "万元",
				},
				]
			},
			{
				type: 5,
				title: "省市招商竞争力",
				order_type: 1,
				de_order_type: 1,
				order_title: "招引上市公司投资项目数",
				order_unit: "",
				order_list: [{
					value: 1,
					name: "招引上市公司投资项目数",
					unit: "",
				},
				{
					value: 2,
					name: "招引上市公司投资项目金额",
					unit: "万元",
				},
				{
					value: 3,
					name: "招商企业拿地投资项目数",
					unit: "",
				},
				{
					value: 4,
					name: "招商企业拿地投资项目面积",
					unit: "亩",
				},
				{
					value: 5,
					name: "招商企业拿地投资项目金额",
					unit: "万元",
				},
				]
			},
			{
				type: 6,
				title: "省市对外投资竞争力",
				order_type: 1,
				de_order_type: 1,
				order_title: "上市公司对外投资项目数",
				order_unit: "",
				order_list: [{
					value: 1,
					name: "上市公司对外投资项目数",
					unit: "",
				},
				{
					value: 2,
					name: "上市公司对外投资项目金额",
					unit: "万元",
				},
				{
					value: 3,
					name: "企业拿地对外投资项目数",
					unit: "",
				},
				{
					value: 4,
					name: "企业拿地对外投资项目面积",
					unit: "亩",
				},
				{
					value: 5,
					name: "企业拿地对外投资项目金额",
					unit: "万元",
				},
				]
			},
			],
			// notionCode: "A", 
			isClearNotion: false,
			notionstep: 0,
			citymapdata_province: [],
			selectcitydata: [],
			isshowWaterMark: false,
			isShowFreeUserTips:false,//是否显示VIP弹框
		}
	},
	watch: {
		$route: function (newVal, oldVal) {
			this.getCurPage('clear')
		}
	},
	created() {
		this.userdata = this.getuseriformation();
		this.userdata.groupType == 2 ? this.isshowWaterMark = true : this.isshowWaterMark = false;
	},
	mounted() {
		this.getCurPage();
	},
	methods: {
		//投资动态跳转到投资项目库页面
		openProjectLink(url) {
			if (url && url != '') {
				window.open(url); //研究报告库外部跳转
			}
		},
		//初始化执行函数 归零
		getCurPage(type) {
			this.area_type = this.$route.query.type ? this.$route.query.type : 1;
			// this.area_type=this.area_type_en=='province'?'省':'市';
			this.itemcode = this.area_type == 1 ? 'J-SSJZL' : 'J-CSJZL';
			var moneyUnit = this.area_type == 1 ? '亿元' : '万元';
			this.cur_type = 1;
			var that = this;
			this.showEchart = true;
			this.type_list.forEach(list => {
				if (list.type == 1) {
					list.de_order_type = that.area_type == 1 ? 1 : 5;
				};
				if (list.type > 3) {
					list.order_unit = '';
				}
				if (list.type != 3) {
					list.order_type = list.de_order_type;
					list.order_list.forEach(item => {
						if (item.name.indexOf('金额') > 0) {
							item.unit = '亿元';
						}
						if (item.value == list.de_order_type) {
							list.order_title = item.name;
						}
					})
				} else {
					list.notion_code = 'A';
					list.order_title = "先进制造业";
				}
			})
			this.cur_order_list = this.type_list[this.cur_type - 1].order_list;
			this.cur_order_type = this.type_list[this.cur_type - 1].order_type;
			this.cur_order_title = this.type_list[this.cur_type - 1].order_title;
			this.getCurOrderUnit(this.type_list[this.cur_type - 1].order_unit);
			if (type) {
				this.isClearNotion = true;
				this.navToggleNum++;
			}
			this.getTableList();
		},
		//柱状图 饼状图 分布地图切换
		getEchartType(type) {
			if(!this.userdata.token && type != 'bar'){
						this.isShowFreeUserTips = true;
						return;
					}
			this.echart_type = type;
			if (type == 'bar') {
				this.qyjz_bar(this.tableData);
			} else if (type == 'pie') {
				this.zsdt_pie(this.tableData);
			} else if (type == 'map') {
				this.cityDataFilter(this.tableData);
			}
		},
		//标题的省市城市切换
		replaceTitleKey(title) {
			if (this.area_type == 1) {
				return title.replace('城市', '省市')
			} else {
				return title.replace('省市', '城市')
			}
		},
		//切换页面类型
		getCurType(data) {
			console.log(data);
			this.cur_type = data.type;
			this.cur_order_list = data.order_list;
			this.cur_order_type = data.order_type;
			this.cur_order_title = data.order_title;
			this.getCurOrderUnit(data.order_unit);
			// this.cur_order_unit=data.order_unit == '' ? '个':data.order_unit;
			this.getTableList();
		},
		//切换竞争力排名（世界500强）
		getCurOrderType(data) {
			if(!this.userdata.token ){
				this.isShowFreeUserTips = true;
				return;
			}
			this.cur_order_type = data.value;
			this.cur_order_title = data.name;
			this.getCurOrderUnit(data.unit);
			// this.cur_order_unit=data.unit == '' ? '个':data.order_unit;
			this.type_list.forEach(list => {
				if (list.type == this.cur_type) {
					list.order_type = data.value;
					list.order_title = data.name;
					list.order_unit = data.unit;
				}
			});
			this.getTableList();
		},
		//切换竞争力排名（产业行业概念）
		chooseNotion(chooseNotionlist, notionCode, step, notionText) {
			this.type_list[2].notion_code = notionCode;
			this.type_list[2].order_title = notionText;
			this.cur_order_title = notionText;
			if (step) {
				this.notionstep = step;
			}
			this.getTableList();
		},
		//获取当前的排名计数单位
		getCurOrderUnit(uval) {
			if (uval != '') {
				this.cur_order_unit = uval;
			} else {
				if (this.cur_order_title.indexOf('项目数') < 0) {
					this.cur_order_unit = '';
				} else {
					this.cur_order_unit = '个';
				}
			}
		},
		//表格的名字是根据当前选中的ordertype进行变动的
		tableSortName(data, type) {
			let aary1 = data.filter(list => {
				return list.value != type;
			});
			let aary2 = data.filter(list => {
				return list.value == type;
			});
			return aary2.concat(aary1);
		},
		//获取当前数据接口地址
		getCurApiUrl() {
			var arg = {
				areaType: this.area_type,
				pieSize: 20
			},
				urls = "";
			let prot = this.$api.cyl.competitive;
			if(this.curWebsite.type == 10){ // 免费版产业大脑不需要登陆的
				prot = this.$api.free.competitive;
			}else {
				prot = this.$api.cyl.competitive;
			}
			if (this.cur_type == 3) {
				arg.notionCode = this.type_list[2].notion_code
			} else {
				arg.orderType = this.type_list[this.cur_type - 1].order_type;
			}
			if (this.cur_type == 1) {
				urls = prot.comprehensive(arg);
			} else if (this.cur_type == 2) {
				urls = prot.scienceTech(arg);
			} else if (this.cur_type == 3) {
				urls = prot.industry(arg);
			} else if (this.cur_type == 4) {
				urls = prot.localInvest(arg);
			} else if (this.cur_type == 5) {
				urls = prot.financing(arg);
			} else if (this.cur_type == 6) {
				urls = prot.externalInvest(arg);
			}
			return urls;
		},
		//获取表格滚动排序的名字
		getCurOrderName(data) {
			if (this.cur_type != 3) {
				this.table_cur_sort = this.tableSortName(this.cur_order_list, this.cur_order_type);
			} else {
				data.forEach(list => {
					list.unit = "";
				})
				this.table_cur_sort = data;
				this.type_list[2].order_title = data[0].name;
				this.cur_order_title = data[0].name;
			}
		},
		//万元亿元切换
		getMoneyNum(title, val) {
			if (title.indexOf('金额') > 0) {
				val = val / 10000;
				val = val.toFixed(2);
			};
			return val;
		},
		//获取表格列表
		getTableList() {
			let ajaxurl = this.getCurApiUrl();
			// console.log('ajaxurl', ajaxurl);
			this.bus.$emit('loading', true);
			// return;
			var that = this;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('ajaxurl', ajaxurl, res.data);
				// console.log(that.type_list[that.cur_type-1].title,res.data) 
				var pieData = res.data.extend.pie;
				var tableData = res.data.list;
				if (that.cur_type == 3 && that.curWebsite.type !=10) { //免费版没有饼图数据，在这加载会报错，判断一下是不是免费版
					that.isClearNotion = false;
					pieData = pieData.filter(list => {
						return list.name != '环保';
					})
				};
				that.pieData = pieData;
				var gatname = "&台湾省香港澳门"
				// data=data.reverse();
				tableData = tableData.reverse();
				if (that.area_type == 2) {
					tableData = tableData.filter(list => {
						return list.data[0] > 0;
					})
				} else {
					tableData = tableData.filter(list => {
						return gatname.indexOf(list.areaName) < 0;
					})
				}
				that.tableData = tableData;
				that.getEchartType('bar')

				// that.getCurOrderName(pieData); 没有表格了 不需要名字重排序了

				// setTimeout(() => {
				// 	that.rowTable()
				// })
				// if(that.$refs.tableData && that.$refs.tableData.doLayout){
				// 	that.$refs.tableData.doLayout();
				// }
				that.refreshNum++;
				that.bus.$emit('loading', false);
			})
		},
		rowTable() {
			this.$nextTick(() => {
				const tableRows = document.querySelectorAll('competitiven-table-td');
				let top = 0;
				tableRows.forEach((item, index) => {
					//前四行固定
					if (index < 4) {
						item.style.position = 'sticky'
						item.style.top = top + 'px'
						item.style.zIndex = 2
						top += item.offsetHeight
					}
					//第一列固定
					item.getElementsByTagName('td')[0].style.position = 'sticky'
					item.getElementsByTagName('td')[0].style.left = 0
					item.getElementsByTagName('td')[0].style.zIndex = 1
					item.getElementsByTagName('td')[0].style.backgroundColor = '#fff'
				})
			})
		},
		//全国省份地图-点击
		chartmapclick: function (data) {
			var type = "";
			if (data.data != undefined && data.data.length > 0) {
				type = 1;
			};
		},
		choosecity(id, i) {
			console.log('全国省份地图-点击')
		},
		//城市数据筛选地图
		cityDataFilter(citytest) {
			// console.log('citytest',citytest); 
			var citylistd = [];
			for (var i = 0; i < citytest.length; i++) {
				let citylista = {};
				citylista.value = this.getMoneyNum(this.cur_order_title, citytest[i].data[0]);
				citylista.id = citytest[i].areaId;

				citylista.name = this.area_type == 1 ? this.citynameremove(citytest[i].areaName) : citytest[i]
					.areaName;
				if (citytest[i].data[0] > 0) {
					citylistd.push(citylista);
				}
			};
			// if(_this.notioneditbtn){
			this.selectcitydata = citytest;
			if (this.area_type == 1) {
				this.citymapdata_province = citylistd;
			} else {
				this.chianmapFun('map-hot-big', citylistd);
			}


			// this.zsdt_pie(citylistd);
		},
		//柱状图
		qyjz_bar(data) {
			//排序
			data.sort((a, b) => {
				return a.data[0] - b.data[0]; // 倒序排序
			});
			// console.log('柱状图', data);
			var chart = echarts.init(document.getElementById('qyjz_bar'));
			var namedata = [], valuedata = [], indexdata = [], sortdata = [], curcityname = this.userdata.province;
			data.forEach((list, i) => {
				let num2 = (i - data.length) * -1;
				indexdata.push({ name: list.areaName, sort: num2 });
			})
			var usercitydata = data.filter(list => {
				return list.areaId == this.userdata.currentCity.id;
			});
			
			if (this.area_type == 2) {
				curcityname = this.userdata.currentCity.name;
				//将当前城市剥离出来，重新放入到第一个
				data = data.filter(list => {
					return list.areaId != this.userdata.currentCity.id && list.data[0] > 0;
				});

			}
			data.forEach((list, i) => {
				var value1 = this.getMoneyNum(this.cur_order_title, list.data[0]);
				namedata.push(list.areaName);

				if (this.area_type == 1 && list.areaId == this.userdata.province) {
					valuedata.push({ value: value1, itemStyle: { color: '#f60' } });
				} else {
					valuedata.push(value1);
				}
			});
			if (this.area_type == 2) {
				usercitydata.forEach(list => {
					var value1 = this.getMoneyNum(this.cur_order_title, list.data[0]);
					namedata.push(list.areaName);
					valuedata.push({ value: value1, itemStyle: { color: '#f60' } });
				})
			}
			// console.log(data,namedata,valuedata);
			for (var i = 0; i < namedata.length; i++) {
				for (var d = 0; d < indexdata.length; d++) {
					if (namedata[i] == indexdata[d].name) {
						// console.log(i,indexdata[d].name)
						sortdata[i] = indexdata[d].sort;
					}
				}
			}
			// console.log(sortdata)
			var barUnit = this.cur_order_unit;
			var that = this, namelength = namedata.length,
				option = {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: namedata,
						axisLabel: {
							formatter: function (a, b) {
								// console.log(a,b); 
								return sortdata[b] + " " + a;
							},
							textStyle: {
								color: "#666",
								fontSize: 14,
							}
						},
					},
					series: [
						{
							name: '',
							type: 'bar',
							data: valuedata,
							// barCategoryGap:20,
							label: {
								show: true,   // 显示标签 
								position: 'right',
								formatter: '{c}' + barUnit,
								textStyle: {
									color: '#666',   // 设置颜色为红色 
									fontSize: 14       // 设置字体大小为16px
								}
							},
						},
					]
				};
			// var dataLength = option.series[0].data.length; // 获取数据长度
			// console.log('dataLength',dataLength);
			// if (dataLength < 80) {
			//     option.series[0].barWidth = 60; // 若数据超过三项则设置宽度为80px
			// } else if (dataLength < 150) {
			//     option.series[0].barWidth = 40; // 若只有三项数据则设置宽度为60px
			// } else if (dataLength >149) {
			//     option.series[0].barWidth = 20; // 其他情况下设置宽度为40px
			// }
			//绑定图表
			chart.setOption(option);
			//根据柱状图y轴的长度 option.yAxis.data.length
			//可以f12调试下，我这边是根据option.yAxis.data[0].length 获取绑定数据集的长度，每个大概30px 
			var autoHeight = option.yAxis.data.length * 30 + 100;
			chart.getDom().style.height = autoHeight + "px";
			chart.getDom().childNodes[0].style.height = autoHeight + "px";
			chart.getDom().childNodes[0].childNodes[0].setAttribute("height", autoHeight);
			chart.getDom().childNodes[0].childNodes[0].style.height = autoHeight + "px";
			//根据窗口的大小变动图表
			chart.resize();

			// chart.setOption(option);
		},
		sortKey(array, key) {//正序从大到小
			return array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				return ((x > y) ? -1 : (x < y) ? 1 : 0)
			})
		},
		//饼图
		zsdt_pie(data) {

			// return;
			var pieUnit = this.cur_order_unit;
			var chart = echarts.init(document.getElementById('conallEnterprise_pie_db'));
			var sdata = [], sdata_other = [], ortherCount = 0;
			var that = this;
			for (var i = 0; i < data.length; i++) {
				let citylista = {};
				citylista.value = this.getMoneyNum(this.cur_order_title, data[i].data[0]);
				citylista.name = data[i].areaName;
				sdata.push(citylista);
			};

			sdata = this.sortKey(sdata, 'value');
			for (var i = 0; i < sdata.length; i++) {
				if (i < 20) {
					sdata_other.push(sdata[i]);
				} else {
					console.log(i, ortherCount, sdata[i].value)
					ortherCount = sdata[i].value + ortherCount;
				}
			}
			if (ortherCount > 0) {
				let otherName = this.area_type == 2 ? '其他城市' : '其他省'
				sdata_other.push({ name: otherName, value: ortherCount });
			}
			console.log('招商地图的饼图', sdata_other);
			var option = {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c}' + pieUnit + ' ({d}%)'
				},
				series: [{
					name: that.cur_order_title,
					type: 'pie',
					radius: ['0%', '60%'],
					labelLine: {
						length: 30
					},
					label: {
						show: true,
						position: 'outside',
						color: '#000',
						fontSize: 12,
						formatter: '{b},{d}' + '%',
					},
					data: sdata_other,
				}]
			};
			chart.setOption(option);
		},
		//城市热点地图
		//区域分布地图
		chianmapFun(el, data) {
			if (data.length < 1) {
				return;
			}
			var that = this;
			// console.log('拿地项目地图分布',el,data);
			var myChart = echarts.init(document.getElementById(el));
			myChart.showLoading({
				text: 'loading',
				color: '#3A568E',
				textColor: '#000',
				maskColor: 'rgba(255, 255, 255, 1)',
				zlevel: 1,
			});
			var loadedDataURL = 'map/china.json';
			// 注意引入版本 
			var geoCoordMap = this.$geoJson;
			var _this = this;
			$.getJSON(loadedDataURL, function (geoJson) {
				// 注册地图名字(tongren)和数据(geoJson) 
				echarts.registerMap('china', geoJson);
				var scaData = [],
					maptitle = '',
					symbolSizeData = [],
					testdata = [];
				for (var i = 0; i < data.length; i++) {
					var geoCoord = geoCoordMap[data[i].name];
					if (data[i].name.indexOf('恩施') > -1) {
						console.log('geoCoord', data[i].name, geoCoord)
					}
					// console.log(geoCoord)
					if (geoCoord) {
						var value1 = [],
							scdataSm = {};
						value1 = geoCoord.concat(data[i].value) //通过数值分布显示光圈大小  
						scdataSm = {
							name: data[i].name,
							value: value1,
							areaId: data[i].areaId,
						}
						scaData.push(scdataSm);
					}
				}
				var size10 = [5, 8, 12, 14, 16, 18, 20, 22, 24, 26];
				var size10sm = [5, 6, 8, 8, 8, 9, 9, 10, 11, 15];
				// var size10sm1 = [5, 6, 7, 8, 9, 10, 10, 10, 10, 10];
				var size10sm1 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
				var repeatNum = 0,
					a1 = [{
						value: scaData[0].value[2],
						index: 0
					}];
				for (var i = 1; i < scaData.length; i++) {
					if (scaData[i].value[2] != scaData[i - 1].value[2]) {
						repeatNum++;
					}
					var a2 = {
						value: scaData[i].value[2],
						index: repeatNum
					};
					a1.push(a2);
				}
				// console.log('a1',a1,repeatNum,size10)
				for (var i = 0; i < a1.length; i++) {
					let size = 8,
						inda = repeatNum - a1[i].index;
					let b1num = parseInt(inda / 10) + 1; //把排序分十份 
					if (repeatNum > 10) {
						inda = parseInt(inda / b1num);
					}
					if (repeatNum > 10 && a1.length > 30 && a1.length < 100) {
						size = size10sm[inda];
					} else {
						size = size10[inda];
					}
					if (a1.length > 99) {
						size = size10sm1[inda];
					}
					// console.log(b1num)
					symbolSizeData.push(size);
				}
				var option = {
					backgroundColor: '#fff',
					title: {
						text: '',
						left: 'center',
						top: 20,
						textStyle: {
							color: '#666',
							fontSize: 16
						}
					},
					tooltip: { //提示框组件
						trigger: 'item',
						formatter: function (params) {
							// console.log(params)
							return params.name;
						},
						show: true,
					},

					legend: { //图例
						orient: 'vertical',
						show: false,
						y: 'bottom',
						x: 'right',
					},
					geo: {
						map: "china",
						silent: true,
						// layoutCenter: ['49%', '49%'],
						layoutSize: '100%',
						roam: false,
						// center: [105.87, 38],
						zoom: 1.2,
						label: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						itemStyle: {
							normal: {
								areaColor: "#2e579d",
								borderColor: "#fff"
							},
							emphasis: {
								areaColor: "#fff"
							}
						}
					},
					series: [{
						name: '',
						type: 'effectScatter',
						coordinateSystem: 'geo',
						data: scaData, //选取从 start 到数组结尾的所有元素，该方法并不会修改数组，而是返回一个子数组 
						symbolSize: function (val, ser) {
							// console.log(val[2],title,ser.dataIndex)
							return symbolSizeData[ser.dataIndex];
							// return _this.mapSymbolSize(val,ser.dataIndex,symbolSizeData);
						},
						showEffectOn: 'render',
						rippleEffect: {
							brushType: 'stroke'
						},
						tooltip: {
							show: true,
							formatter: function (params) {
								// console.log(params)
								// var result = '<h3 style="font-size:15px;line-height:20px;margin-bottom:5px">'+params.name+that.cur_order_title+'</h3>';
								var result = '<div style="line-height:20px">' + params.name +
									':' + params.value[2] + that.cur_order_unit + '</div>';
								return result;

							},
						},
						hoverAnimation: true,
						label: {
							normal: {
								formatter: '{b}:{@2}',
								position: 'right',
								show: false
							},
							emphasis: {
								show: true
							}
						},
						itemStyle: {
							normal: {
								color: '#f4e925',
								shadowBlur: 10,
								shadowColor: '#333'
							}
						},
						zlevel: 1
					},]
				};

				myChart.hideLoading();
				myChart.setOption(option);

			})
		}
	}
}
</script>

<style scoped>
.recommd-map {
	height: auto;
	/* min-height: 600px; */
}

.map-hot-big {
	width: 100%;
	/* 	position: absolute;
		left: 0;
		top: 0; */
	height: 800px;
	margin: 0 auto;
}

.listclose_btn {
	width: auto;
	padding-right: 20px;
	padding-left: 20px;
}

#conallEnterprise_pie_db {
	width: 100%;
	height: 500px;
}
</style>